import React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { hk_lat_lng } from '@/constants/map';
import { LatLng } from '@/models/core.model';

type MapSelectorProps = {
  value: LatLng | null;
  onChange: (position: LatLng) => void;
  defaultCenter?: LatLng;
  height?: string;
  disabled?: boolean;
};

const MapSelector: React.FC<MapSelectorProps> = ({
  value,
  onChange,
  defaultCenter = hk_lat_lng,
  height = '350px',
  disabled = false,
}) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_MAP_API_KEY!,
  });

  const handleMapClick = (e: google.maps.MapMouseEvent) => {
    if(disabled){
      return;
    }
    if (e.latLng) {
      const position = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      };
      onChange(position);
    }
  };

  if (!isLoaded) return <h6>Loading Map...</h6>;

  return (
    <GoogleMap
      mapContainerStyle={{ width: '100%', height, borderRadius: 10 }}
      center={value || defaultCenter}
      zoom={value ? 15 : 8}
      onClick={handleMapClick}
    >
      {value && <Marker position={value} />}
    </GoogleMap>
  );
};

export default MapSelector;